module.exports = __webpack_public_path__ + "h5/img/3.af460856.jpg";